import { TemplatePart, TemplatePartTypes } from "../types";

export default function filterTemplateParts<T extends TemplatePart>(
  parts: TemplatePart[],
  type: TemplatePartTypes
) {
  return parts.filter(part => part.type === type) as T[];
}
